import React from "react";
import EASkeletonLoader from "../../shared/EASkeletonLoader";
import { Assort } from "../../../models/Assort";
import AssortCard from "./AssortCard";
import { useTranslation } from "react-i18next";

interface IProps {
  assorts: Assort[];
  loading: boolean;
  onAssortAdd: (assort: Assort) => void;
  onAssortDelete: (assort: Assort) => void;
  getQnt: (assort: Assort) => number;
  ticketsInCurrentBasket: () => number;
  getTicketLimit: () => number;
}

const SaleSummary: React.FC<IProps> = ({
  assorts,
  loading,
  onAssortAdd,
  onAssortDelete,
  getQnt,
  ticketsInCurrentBasket,
  getTicketLimit,
}) => {
  const { t } = useTranslation();

  if (loading) {
    return <EASkeletonLoader height="200px" />;
  }

  return (
    <>
      <div className="gdansk-sale-assorts">
        {assorts && assorts.length > 0 ? (
          <>
            {assorts.map((item, index) => (
              <AssortCard
                assort={item}
                key={index}
                onAdd={onAssortAdd}
                onDelete={onAssortDelete}
                qnt={getQnt(item)}
                disabledAdding={
                  !Boolean(
                    getQnt(item) < (item.maxSale === 0 ? 99 : item.maxSale) &&
                      ticketsInCurrentBasket() < getTicketLimit()
                  )
                }
              />
            ))}
          </>
        ) : (
          <div className="alert alert-yellow">Nie znaleźliśmy żadnych dostępnych karnetów</div>
        )}
      </div>
      {getTicketLimit() === ticketsInCurrentBasket() && (
        <div className="flex-between-center alert alert-yellow">
          <b>{t("nie_mozesz_dodac_wiekszej_ilosci_biletow_do_koszyka")}</b>
        </div>
      )}
    </>
  );
};

export default SaleSummary;
